module.exports = __webpack_public_path__ + "img/feature-2.c3d7c2d0.jpg";